export default __webpack_public_path__ + "//i/components/icon/map/car//neutral.png";